function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerfectMagicCubeLines950(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "221.5pt",
    height: "240.37pt",
    viewBox: "0 0 221.5 240.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 935.128805 1287.970864 L 2162.830337 2059.597354 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,100%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 63.984352 1753.092993 L 935.128805 1287.970864 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 935.128805 1287.970864 L 1472.82346 66.183229 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 935.128805 1287.970864 L 1539.756242 1296.117159 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 935.128805 1287.970864 L 899.292939 2354.27392 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 240.657131 578.068227 L 935.128805 1287.970864 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 935.128805 1287.970864 L 2015.883703 934.625305 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,100%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 397.473316 1649.815201 L 1187.233146 1205.567954 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1187.233146 1205.567954 L 1190.64049 2286.322851 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 523.975882 460.338594 L 1187.233146 1205.567954 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 927.100005 1526.71998 L 1487.196971 330.428683 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 202.040559 835.029012 L 927.100005 1526.71998 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 927.100005 1526.71998 L 2048.390554 1183.596455 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 783.404055 1132.877934 L 2032.607107 1900.000463 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 783.404055 1132.877934 L 721.092729 2226.008934 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 783.404055 1132.877934 L 1898.937367 747.652162 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,100%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 753.051273 1539.72272 L 1450.812796 1119.405215 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1450.812796 1119.405215 L 1497.45817 2214.768613 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 822.843091 336.18592 L 1450.812796 1119.405215 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 496.442971 719.414283 L 1187.977279 1446.901952 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1042.793064 1043.307851 L 1022.231501 2151.164846 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,100%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1132.95062 1422.110582 L 1726.729385 1029.169329 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1726.729385 1029.169329 L 1821.038419 2139.297887 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1138.668693 204.983568 L 1726.729385 1029.169329 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 918.483731 1782.701643 L 1502.980418 620.679617 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 160.055806 1114.352945 L 918.483731 1782.701643 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 918.483731 1782.701643 L 2083.482288 1452.34587 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 769.539688 1376.405165 L 1928.350193 1001.088109 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 807.725447 597.219854 L 1461.19149 1363.28493 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 618.363246 964.194791 L 1887.344563 1722.035242 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 618.363246 964.194791 L 524.563355 2084.584548 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 618.363246 964.194791 L 1770.711546 542.506514 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1314.558175 949.468795 L 1340.172007 2072.130116 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 899.292939 2354.27392 L 2015.883703 934.625305 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,100%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1539.756242 1296.117159 L 2015.883703 934.625305 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 240.657131 578.068227 L 2015.883703 934.625305 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 63.984352 1753.092993 L 2015.883703 934.625305 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2015.883703 934.625305 L 2162.830337 2059.597354 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1472.82346 66.183229 L 2015.883703 934.625305 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 466.403507 1001.714747 L 1188.799741 1706.055971 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1137.415417 467.740756 L 1747.682596 1275.594761 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 909.279984 2057.795769 L 1520.40879 940.930851 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 114.19373 1419.173216 L 909.279984 2057.795769 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 909.279984 2057.795769 L 2121.511387 1743.380103 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 885.428571 866.439247 L 836.002491 2001.711659 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1599.639345 851.008284 L 1676.441677 1988.552259 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 754.617868 1638.261561 L 1960.191242 1275.712256 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 791.197867 882.340189 L 1472.353481 1625.65047 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 597.605859 1212.382643 L 1796.168719 800.093938 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 438.204792 780.002354 L 1724.222832 1522.137689 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 438.204792 780.002354 L 306.767451 1927.846693 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 438.204792 780.002354 L 1629.326325 316.44682 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 202.040559 835.029012 L 2048.390554 1183.596455 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1487.196971 330.428683 L 2048.390554 1183.596455 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 433.544171 1310.569 L 1189.661368 1985.066585 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1165.770791 763.866423 L 1165.770791 1913.982325 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 721.092729 2226.008934 L 1898.937367 747.652162 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1898.937367 747.652162 L 2032.607107 1900.000463 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1136.083811 755.563468 L 1770.241568 1541.171821 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,100%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 240.657131 578.068227 L 899.292939 2354.27392 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 899.292939 2354.27392 L 1539.756242 1296.117159 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1472.82346 66.183229 L 899.292939 2354.27392 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 63.984352 1753.092993 L 899.292939 2354.27392 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 899.292939 2354.27392 L 2162.830337 2059.597354 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 738.521102 1920.640355 L 1994.812997 1574.266145 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 713.181423 672.964734 L 628.976929 1835.613398 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 773.025362 1195.11093 L 1484.416265 1908.616736 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1460.486522 656.00634 L 1515.59151 1820.926567 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 575.164382 1480.192101 L 1823.897455 1080.396993 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 409.261945 1032.694168 L 1649.887888 577.794072 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 160.055806 1114.352945 L 2083.482288 1452.34587 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1502.980418 620.679617 L 2083.482288 1452.34587 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,100%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 523.975882 460.338594 L 1190.64049 2286.322851 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 397.473316 1649.815201 L 1190.64049 2286.322851 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 240.657131 578.068227 L 1539.756242 1296.117159 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 240.657131 578.068227 L 2162.830337 2059.597354 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 240.657131 578.068227 L 63.984352 1753.092993 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 240.657131 578.068227 L 1472.82346 66.183229 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1002.609896 560.3657 L 971.277991 1737.622865 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1134.595545 1072.172368 L 1794.602124 1828.17207 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 524.563355 2084.584548 L 1770.711546 542.506514 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1770.711546 542.506514 L 1887.344563 1722.035242 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 721.092729 2226.008934 L 2032.607107 1900.000463 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,100%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 822.843091 336.18592 L 1497.45817 2214.768613 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 753.051273 1539.72272 L 1497.45817 2214.768613 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 550.921321 1769.973057 L 1854.132743 1386.431375 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 523.975882 460.338594 L 397.473316 1649.815201 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1307.547661 441.69611 L 1335.628881 1633.365951 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 377.93004 1306.339193 L 1672.36853 863.345221 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 114.19373 1419.173216 L 2121.511387 1743.380103 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1520.40879 940.930851 L 2121.511387 1743.380103 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 202.040559 835.029012 L 1487.196971 330.428683 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,100%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1138.668693 204.983568 L 1821.038419 2139.297887 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1132.95062 1422.110582 L 1821.038419 2139.297887 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 822.843091 336.18592 L 753.051273 1539.72272 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 306.767451 1927.846693 L 1629.326325 316.44682 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1629.326325 316.44682 L 1724.222832 1522.137689 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 524.563355 2084.584548 L 1887.344563 1722.035242 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 343.895758 1603.678971 L 1697.00324 1176.703436 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,100%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1472.82346 66.183229 L 2162.830337 2059.597354 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 63.984352 1753.092993 L 2162.830337 2059.597354 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1539.756242 1296.117159 L 2162.830337 2059.597354 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1138.668693 204.983568 L 1132.95062 1422.110582 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 160.055806 1114.352945 L 1502.980418 620.679617 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.1442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 63.984352 1753.092993 L 1472.82346 66.183229 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1472.82346 66.183229 L 1539.756242 1296.117159 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 306.767451 1927.846693 L 1724.222832 1522.137689 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 114.19373 1419.173216 L 1520.40879 940.930851 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(50%,50%,50%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 63.984352 1753.092993 L 1539.756242 1296.117159 ",
    transform: "matrix(0.0997386,0,0,-0.0997386,0.040166,239.741647)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfectMagicCubeLines950);
export default __webpack_public_path__ + "static/media/PerfectMagicCubeLines_950.0b535be66d01463e366aabdecb50a4cb.svg";
export { ForwardRef as ReactComponent };